var map = {
	"./componenteditor/componenteditor.module": [
		"./src/app/componenteditor/componenteditor.module.ts",
		"common",
		"componenteditor-componenteditor-module"
	],
	"./designer/designer.module": [
		"./src/app/designer/designer.module.ts",
		"designer-designer-module"
	],
	"./documenttemplates/documenttemplates.module": [
		"./src/app/documenttemplates/documenttemplates.module.ts",
		"common",
		"documenttemplates-documenttemplates-module"
	],
	"./drawings/drawings.module": [
		"./src/app/drawings/drawings.module.ts",
		"common",
		"drawings-drawings-module"
	],
	"./universe/universe.module": [
		"./src/app/universe/universe.module.ts",
		"common",
		"universe-universe-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;